import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.getters.logged)?_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"12","sm":"8","md":"4"}},[_c(VCard,{staticClass:"elevation-4"},[_c('CsrfToken',{on:{"loaded":_vm.csrf_token}}),_c(VCardText,[_vm._v(" Buscando os dados de usuário e token de acesso... ")])],1),_c(VOverlay,{attrs:{"value":_vm.loading}},[_c('PProgressCircular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }